import { FC, useState, useEffect } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Paper,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIContent } from '../../../atomic/organisms';
import { CacheQuery } from '../../../services/query';
import TimeHelper from '../../../utils/time';
import { CacheCommand } from '../../../services/command';
import { SCUIButton } from '../../../atomic/atoms';

import { SCUIGeneralModal, SCUICustomDataGrid } from '../../../atomic/molecules';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';
import Swal from 'sweetalert2';

export const CacheManagement: FC<any> = () => {
    const { t } = useTranslation();
    const [cacheNames, setCacheNames] = useState([]);
    const [display, setDisplay] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [description, setDescription] = useState('');
    const [cacheTemplate, setCacheTemplate] = useState('');
    const [redisDb, setRedisDb] = useState('');
    const [CacheTeam, setCacheTeam] = useState([]);
    const [cacheTeamId, setCacheTeamID] = useState(0);
    const [cacheId, setCacheId] = useState();
    const [mode, setMode] = useState('');
    const [cacheManagementIdSil, setCacheManagementIdSil] = useState([]);
    const [redisDbNoSil, setRedisDbNoSil] = useState(0);
    const [cacheParameters, setCacheParameters] = useState([]);
    const [cacheState, setCacheState] = useState<any>();
    const [cacheTeam, setcacheTeam] = useState('');
    const [deleteModal, setDeleteModal] = useState(false);
    const [open, setOpen] = useState(false);
    const [clearCacheModal, setClearCacheModal] = useState(false);
    const [cacheKeyToClear, setCacheKeyToClear] = useState('');

    const handleDeleteModalOpen = () => setDeleteModal(true);
    const handleDeleteModalClose = () => setDeleteModal(false);
    const handleClearCacheModalOpen = () => setClearCacheModal(true);
    const handleClearCacheModalClose = () => {
        setClearCacheModal(false);
        setCacheKeyToClear('');
    };
    const handleValueChange = (_: number, e: any) => {
        setCacheState({ ...cacheState, [e.target.id]: e.target.value });
    };
    const getParamsCache = async () => {
        try {
            let isNull: any = {};
            let paramss: any = {};

            if (cacheParameters === undefined) {
                isNull = false;
            } else {
                await Promise.all(
                    cacheParameters.map(async (item) => {
                        const value = await cacheState[item];

                        if (value === undefined) {
                            isNull = false;
                        }
                        paramss[item] = value;
                    })
                );

                if (cacheParameters.length === 0) {
                    paramss = {};
                    isNull = true;
                }
            }

            let parameters = {
                request: {
                    cacheManagementId: Number(cacheManagementIdSil),
                    cacheParams: paramss,
                    db: Number(redisDbNoSil),
                },
            };

            if (!isNull) {
                return false;
            } else {
                return parameters;
            }
        } catch (error) {
            console.error('Error:', error);
            return false;
        }
    };
    const sil = () => {
        if (!getParamsCache()) {
            Swal.fire(t('general.emptyFieldControlText'), ' ', 'error');
        } else {
            handleDeleteModalClose();

            Swal.fire({
                text: t('general.sureText'),
                cancelButtonText: t('general.cancel'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: t('general.delete'),
            }).then((result: any) => {
                if (result.isConfirmed) {
                    CacheCommand.PostRemoveCacheKey(getParamsCache())
                        .then((res: any) => {
                            console.info(res);
                            Swal.fire(t('general.deleted'), ' ', 'success');
                        })
                        .catch((error: any) => {
                            console.log('Hata :>> ', error);
                        });
                }
            });
        }
    };

    useEffect(() => {
        GetCacheList();
        getTeam();
    }, [refresh]);
    const handleClickOpen = () => {
        setOpen(true);
        setDescription('');
        setRedisDb('');
        setCacheTemplate('');
        setMode('Ekle');
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (event: any) => {
        setcacheTeam(event.target.value as string);
        setCacheTeamID(event.target.value);
    };

    const getTeam = async () => {
        try {
            let team: any = await CacheQuery.ListEcommerceTeam();
            setCacheTeam(team.data);
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };

    const GetCacheList = async (): Promise<any> => {
        CacheQuery.FilterCacheManagement('').then((res: any) => {
            if (res) {
                let parseData = res.data.map((item: any) => {
                    return {
                        id: item.id || '-',
                        mainEcommerceTeamId: item.mainEcommerceTeamId || '-',
                        createdByUserRef: item.createdByUserRef || '-',
                        createdDate: TimeHelper.formatDateHour(item.createdDate) || '-',
                        description: item.description || '-',
                        cacheKeyTemplate: item.cacheKeyTemplate || '-',
                        redisDbNo: item.redisDbNo?.toString() || '-',
                        cacheParameters: item.cacheParameters || [],
                    };
                });
                setCacheNames(parseData);
                setDisplay(true);
            } else {
                Swal.fire(t('general.notFound'), ' ', 'error');
                setCacheNames([]);
                setDisplay(false);
            }
        });
    };

    const CashEkle = async () => {
        let params = {
            request: {
                mainEcommerceTeamId: cacheTeam,
                description: description,
                cacheKeyTemplate: cacheTemplate,
                redisDbNo: redisDb,
            },
        };
        if (redisDb.trim().length > 0 && cacheTemplate.trim().length > 0) {
            {
                CacheCommand.PostCreateCash(params)
                    .then(() => {
                        handleClose();
                        Swal.fire(t('general.added'), ' ', 'success');
                        setRefresh((prevRefreshing) => !prevRefreshing);
                    })
                    .catch((error: any) => {
                        Swal.fire('', ' ', 'error');
                        console.log('Hata :>> ', error);
                    })
                    .finally(() => {});
            }
        } else {
            Swal.fire(t('general.emptyFieldControlText'), ' ', 'error');
        }
    };
    const CashGuncelle = async () => {
        let params = {
            request: {
                id: cacheId,
                mainEcommerceTeamId: cacheTeam,
                description: description,
                cacheKeyTemplate: cacheTemplate,
                redisDbNo: redisDb,
            },
        };
        CacheCommand.PutCreateCash(params)
            .then(() => {
                handleClose();
                Swal.fire(t('general.updated'), ' ', 'success');
                setRefresh((prevRefreshing) => !prevRefreshing);
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    const handleOnCellClick = (params: any) => {
        if (params.field === 'sil') {
            setCacheState(' ');
            setCacheParameters(params.row.cacheParameters);
            setCacheManagementIdSil(params.row.id);
            setRedisDbNoSil(params.row.redisDbNo);
            handleDeleteModalOpen();
        }
        if (params.field === 'düzenle') {
            setMode('guncelle');
            setDescription(params.row.description);
            setCacheTemplate(params.row.cacheKeyTemplate);
            setRedisDb(params.row.redisDbNo);
            setCacheId(params.row.id);
            setCacheTeamID(params.row.mainEcommerceTeamId);
            setOpen(true);
        }
    };

    const handleClearCacheKey = async () => {
        if (!cacheKeyToClear.trim()) {
            Swal.fire(t('general.emptyFieldControlText'), ' ', 'error');
            return;
        }

        try {
            const params = {
                cacheKey: cacheKeyToClear.trim(),
            };

            await CacheCommand.ClearCacheKey(params);
            handleClearCacheModalClose();
            Swal.fire(t('general.success'), t('cacheManagement.clearCacheKey') + ' ' + t('general.success'), 'success');
        } catch (error) {
            console.error('Error clearing cache key:', error);
            Swal.fire(t('general.error'), ' ', 'error');
        }
    };

    return (
        <SCUIContent>
            <Grid container direction="row">
                <Grid
                    size={{
                        lg: 10,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <h1 className="headtxt">{t('dashboard.cacheManagement')}</h1>
                </Grid>
                <SCUIGeneralModal
                    open={deleteModal}
                    onClose={handleDeleteModalClose}
                    title={t('cacheManagement.clearCache')}
                    width={'xs'}
                >
                    <DialogContent>
                        <FormControl fullWidth>
                            {cacheParameters.map((cacheParam, index) => (
                                <TextField
                                    key={index}
                                    margin="dense"
                                    required
                                    id={cacheParam}
                                    label={cacheParam}
                                    fullWidth
                                    variant="standard"
                                    onChange={(e) => handleValueChange(index, e)}
                                />
                            ))}
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDeleteModalClose}>{t('general.cancel')}</Button>
                        <Button onClick={sil}>{t('general.delete')}</Button>{' '}
                    </DialogActions>
                </SCUIGeneralModal>
                <SCUIGeneralModal
                    open={clearCacheModal}
                    onClose={handleClearCacheModalClose}
                    title={t('cacheManagement.clearCacheKey')}
                    width={'md'}
                >
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid
                                size={{
                                    xs: 12,
                                }}
                            >
                                <Typography variant="body2" color="textSecondary" gutterBottom>
                                    {t('cacheManagement.clearCacheKeyDescription')}
                                </Typography>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                }}
                            >
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="cacheKey"
                                    label={t('cacheManagement.enterCacheKey')}
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    value={cacheKeyToClear}
                                    onChange={(e) => setCacheKeyToClear(e.target.value)}
                                    placeholder={t('cacheManagement.cacheKeyPlaceholder')}
                                    helperText={t('cacheManagement.cacheKeyHelperText')}
                                    multiline
                                    rows={3}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                }}
                            >
                                <Typography variant="body2" color="textSecondary">
                                    <strong>{t('cacheManagement.examples')}:</strong>
                                </Typography>
                                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                    • user:123:profile
                                    <br />
                                    • product:*:details
                                    <br />
                                    • session:*
                                    <br />• cache:*
                                </Typography>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClearCacheModalClose} variant="outlined">
                            {t('general.cancel')}
                        </Button>
                        <Button
                            onClick={handleClearCacheKey}
                            variant="contained"
                            color="error"
                            disabled={!cacheKeyToClear.trim()}
                        >
                            {t('cacheManagement.clearCacheKey')}
                        </Button>
                    </DialogActions>
                </SCUIGeneralModal>
                <Grid
                    size={{
                        lg: 2,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <SCUIButton
                            text={t('cacheManagement.addCache')}
                            type="primary"
                            sizeType="fixed"
                            size={'m'}
                            onClick={handleClickOpen}
                        />
                        <SCUIButton
                            text={t('cacheManagement.clearCacheKey')}
                            type="error"
                            sizeType="fixed"
                            size={'m'}
                            onClick={handleClearCacheModalOpen}
                        />
                    </div>
                </Grid>
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle>{t('cacheManagement.cacheInformation')}</DialogTitle>
                    <DialogContent>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="demo-simple-select-label">{t('cacheManagement.team')}</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                value={cacheTeamId}
                                label="setcacheTeam"
                                onChange={handleChange}
                            >
                                {CacheTeam.map((ct: any) => (
                                    <MenuItem key={ct.id} value={ct.id}>
                                        {ct.teamName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label={t('general.description')}
                            type="string"
                            fullWidth
                            multiline
                            rows={2}
                            variant="standard"
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                        />

                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="name"
                            label={t('cacheManagement.template')}
                            type="string"
                            fullWidth
                            variant="standard"
                            onChange={(e) => setCacheTemplate(e.target.value)}
                            value={cacheTemplate}
                        />
                        <p>
                            <small>{t('general.exampleUsage')} : bo_LeftMenu_#!#UserRef#!#</small>
                        </p>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="name"
                            label="Redis DB No"
                            type="number"
                            fullWidth
                            variant="standard"
                            onChange={(e) => setRedisDb(e.target.value)}
                            value={redisDb}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>{t('general.cancel')}</Button>
                        {mode === 'Ekle' ? (
                            <Button onClick={CashEkle}>{t('general.save')}</Button>
                        ) : (
                            <Button onClick={CashGuncelle}>{t('general.update')}</Button>
                        )}
                    </DialogActions>
                </Dialog>
            </Grid>
            <br />
            <Grid container direction="row">
                {display && cacheNames && (
                    <Paper sx={{ width: '100%', margin: '2rem', padding: '2rem' }}>
                        <div style={{ height: '100%', width: '100%' }}>
                            <SCUICustomDataGrid
                                rows={cacheNames}
                                columns={[
                                    { field: 'id', headerName: 'ID', flex: 1, hide: true },
                                    {
                                        field: 'mainEcommerceTeamId',
                                        headerName: 'mainEcommerceTeamId',
                                        flex: 1,
                                        hide: true,
                                    },
                                    {
                                        field: 'createdByUserRef',
                                        headerName: 'createdByUserRef',
                                        flex: 1,
                                        hide: true,
                                    },
                                    {
                                        field: 'description',
                                        headerName: t('general.description'),
                                        flex: 1,
                                        renderCell: (params: any) => (
                                            <Tooltip title={params.row.description} placement="bottom-end" arrow>
                                                <span className="table-cell-trucate">{params.row.description}</span>
                                            </Tooltip>
                                        ),
                                    },
                                    {
                                        field: 'cacheKeyTemplate',
                                        headerName: t('cacheManagement.template'),
                                        flex: 1,
                                    },
                                    {
                                        field: 'createdDate',
                                        headerName: t('general.date'),
                                        flex: 1,
                                    },
                                    { field: 'redisDbNo', headerName: 'Redis DB No', flex: 1 },
                                    {
                                        field: 'düzenle',
                                        headerName: t('general.edit'),
                                        renderCell: () => {
                                            return <EditIcon />;
                                        },
                                    },
                                    {
                                        field: 'sil',
                                        headerName: t('general.delete'),
                                        renderCell: () => {
                                            return <DeleteIcon />;
                                        },
                                    },
                                ]}
                                onCellClick={handleOnCellClick}
                            />
                        </div>
                    </Paper>
                )}
            </Grid>
        </SCUIContent>
    );
};
